import React, { useEffect, useRef, useState } from 'react';
import Layout from './components/Layout';
import SEO from './components/SEO';

const WorkPage: React.FC = () => {
  const [isVisible, setIsVisible] = useState({
    fragment1: false,
    fragment2: false,
    fragment3: false,
    fragment4: false
  });
  
  const fragment1Ref = useRef<HTMLDivElement>(null);
  const fragment2Ref = useRef<HTMLDivElement>(null);
  const fragment3Ref = useRef<HTMLDivElement>(null);
  const fragment4Ref = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      
      if (fragment1Ref.current) {
        const fragment1Position = fragment1Ref.current.offsetTop;
        if (scrollPosition > fragment1Position + 100) {
          setIsVisible(prev => ({ ...prev, fragment1: true }));
        }
      }
      
      if (fragment2Ref.current) {
        const fragment2Position = fragment2Ref.current.offsetTop;
        if (scrollPosition > fragment2Position + 100) {
          setIsVisible(prev => ({ ...prev, fragment2: true }));
        }
      }
      
      if (fragment3Ref.current) {
        const fragment3Position = fragment3Ref.current.offsetTop;
        if (scrollPosition > fragment3Position + 100) {
          setIsVisible(prev => ({ ...prev, fragment3: true }));
        }
      }
      
      if (fragment4Ref.current) {
        const fragment4Position = fragment4Ref.current.offsetTop;
        if (scrollPosition > fragment4Position + 100) {
          setIsVisible(prev => ({ ...prev, fragment4: true }));
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Initial check on mount
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <Layout>
      <SEO 
        title="Archive | noprblm."
        description="noprblm."
        keywords="noprblm, work, archive"
        canonicalUrl="/work"
      />
      <section className="content-section">
        <div className="fragment-container">
          <div 
            ref={fragment1Ref}
            className={`fragment ${isVisible.fragment1 ? 'reveal' : ''}`}
          >
            <p className="category-text">Culture. Science. Technology.</p>
          </div>
          
          <div 
            ref={fragment4Ref}
            className={`fragment ${isVisible.fragment4 ? 'reveal' : ''}`}
          >
            <p className="category-text coming-soon-text">coming soon</p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default WorkPage;